import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
const swal = require('sweetalert');
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-view-pay-out-transactions',
  templateUrl: './view-pay-out-transactions.component.html',
  styleUrls: ['./view-pay-out-transactions.component.scss']
})
export class ViewPayOutTransactionsComponent implements OnInit {
  Amt: any;
  sendotpbtn: boolean = true;
  Rcode: any;
  sendOtpResponseText: any;
  ResponseText: any;
  Otp = new FormControl("", [Validators.required]);
  CurrentIp = localStorage.getItem('ipaddress');;
  IsLocationAllow: boolean = false;
  GeoLocation: any;
  Otptextbox: boolean = false;
  Recivieddata: boolean = false;
  CreatedBy: any;
  Reciviedfrom: any;
  FullAccNo: boolean = false;
  CrossAccNo: boolean = true;
  FullAccountNumber: any;
  Id: any;
  fname: any;
  cancellbutton: boolean = false;
  payoutapprove: boolean = false;
  firstname: any;
  rows;
  viewid: any;
  status: any;
  fltrMerchantkeyId: any;
  requestuniqueid: any;
  ApprovedBy: any;
  constructor(private route: ActivatedRoute, private service: PayoutService, private commonfunction: CommonFunctionService, private router: Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.fltrMerchantkeyId = merchantdata.MerchantKeyId;
    this.service.ViewPayOutTransactionDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
      //   var currentdate=new Date().toISOString().slice(0, 10);
      //  var  date=new Date(result.PayOutDate).toISOString().slice(0, 10);
      var currentdate = new Date();
      var date = new Date(result.PayOutDate);
      if (result.InternalPurpose == "Received" && result.TransactionType == "CREDIT" && result.PayoutCustomerkeyId != null && result.PayoutCustomerkeyId != "") {
        this.Reciviedfrom = result.FirstName + " " + result.LastName;
        this.Recivieddata = true;


      }
      if (result.PayOutType == "scheduled" && date > currentdate && result.Status == 0) {
        this.cancellbutton = true;
      }
      else {
        this.cancellbutton = false;
      }
      this.rows = result;
      this.Id = this.rows.TransactionId
      this.status = this.rows.Status;
      this.requestuniqueid = this.rows.RequestUniqueId;
      this.CreatedBy = this.rows.CreatedBy;
      this.ApprovedBy = this.rows.ApprovedBy;
      this.Amt = this.rows.Amount
      if (this.rows.AccountNumber != null) {
        this.FullAccountNumber = this.rows.AccountNumber
        var first6digits = this.rows.AccountNumber.slice(0, 6);
        var last4digits = this.rows.AccountNumber.slice(-4);
        this.rows.AccountNumber = first6digits + "-XXXXXXX-" + last4digits;
      }

      //  this.rows.forEach(element => {
      //   if (element.AccountNumber !=null) {
      //   var first6digits = element.AccountNumber.slice(0, 6);
      //  var last4digits = element.AccountNumber.slice(-4);
      //     element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      //   }

      // });



      //  if(this.rows.Status==0)
      //  {
      //    this.rows.Status="Pending"
      //  }
      //  else if(this.rows.Status==1)
      //  {
      //    this.rows.Status="Transaction Initiated"
      //  }
      //  else if(this.rows.Status==2)
      //  {
      //    this.rows.Status="Failed"
      //  }
      //  else if(this.rows.Status==3)
      //  {
      //    this.rows.Status="Transferred"
      //  }
      //  else if(this.rows.Status==4)
      //  {
      //    this.rows.Status="Cancelled"
      //  }
      if (this.rows.BankCodeType == 0) {
        this.rows.BankCodeType = "RoutingTransitNumber"
      }
      else if (this.rows.BankCodeType == 1) {
        this.rows.BankCodeType = "BankSortCodes"
      }
      else if (this.rows.BankCodeType == 2) {
        this.rows.BankCodeType = "BsbNumbers"
      }
      else if (this.rows.BankCodeType == 3) {
        this.rows.BankCodeType = "SwiftCode"
      }
      else if (this.rows.BankCodeType == 4) {
        this.rows.BankCodeType = "MicrCode"
      }
      else if (this.rows.BankCodeType == 5) {
        this.rows.BankCodeType = "IfscCode"
      }
      if (this.rows.BankAccountType == 0) {
        this.rows.BankAccountType = "SalaryAccount"
      }
      else if (this.rows.BankAccountType == 1) {
        this.rows.BankAccountType = "CurrentAccount"
      }
      else if (this.rows.BankAccountType == 2) {
        this.rows.BankAccountType = "SavingAccount"
      }
      else if (this.rows.BankAccountType == 3) {
        this.rows.BankAccountType = "RecurringDeposits"
      }
      else if (this.rows.BankAccountType == 4) {
        this.rows.BankAccountType = "FixedDeposits"
      }
      if (this.CreatedBy != null && this.CreatedBy != '' && this.CreatedBy != undefined) {
        this.getmerchantdetailsbyuserid();
      }
      if (this.ApprovedBy != null && this.ApprovedBy != '') {
        this.getuserdetails();
      }

    })

  }

  ngOnInit() {
    this.getpermission(); 
    this.getUserLocation();
  }

  getmerchantdetailsbyuserid() {
    this.service.GetuserdetailsbyUserid(this.CreatedBy).subscribe(result => {
      if (result != null) {
        this.fname = result[0].FirstName;
      }
    });
  }
  SchedulePayment() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.CancellSchedulePayment(this.Id, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {
        window.location.reload();
      }
    });

  }
  ApprovePayout() {
    let form = {
      MerchantKeyId: 0,
      TransactionId: 0,
      UniqueRequestId: "",
      ApprovedBy: "",
      LoginUserId: ''
    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.TransactionId = this.Id;
    form.UniqueRequestId = this.requestuniqueid;
    form.ApprovedBy = merchantdata.UserId;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.payoutfundbanktransfer(form).subscribe(result => {
      if (result != null) {
        swal("Approved", "Payout transaction Approved successfully", "success");
        this.router.navigate(["PayOut/PayOutTransactions"]);
        //this.openpopup();

      }
    });

  }
  DeclinePayouttransaction() {
    let form = {
      MerchantKeyId: 0,
      TransactionId: 0,
      UniqueRequestId: "",
      ApprovedBy: "",
      LoginUserId: ''

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.TransactionId = this.Id;
    form.UniqueRequestId = this.requestuniqueid;
    form.ApprovedBy = merchantdata.UserId;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.DeclinePayouttransaction(form).subscribe(result => {
      if (result != null) {
        swal("Declined", "Payout transaction Declined successfully", "warning");
        this.router.navigate(["PayOut/PayOutTransactions"]);
        //this.openpopup();

      }
    });

  }
  openpopup() {

    swal({

      title: 'Are you sure you want to Approve Transaction',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.ApprovePayout();

      }
    });
  }
  getuserdetails() {
    this.service.GetuserdetailsbyUserid(this.ApprovedBy).subscribe(result => {
      if (result != null) {
        this.firstname = result[0].FirstName;
      }
    });
  }
  Declinepopup() {

    swal({

      title: 'Are you sure you want to Decline Transaction',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.DeclinePayouttransaction();

      }
    });
  }
  getpermission() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetuserRoleBasedPermissions(merchantdata.UserId, merchantdata.UserType).subscribe(result => {
      if (result != null) {
        for (var i in result) {
          if (result[i].UserPermission == 'PayOutApprove') {
            var type = result[i].Type;
            if (type == 'RWD') {
              this.payoutapprove = true;
            }
            else {
              this.payoutapprove = false;
            }

          }






        }
      }
    });
  }


  onSelect(x) {
    this.FullAccNo = true;
    this.CrossAccNo = false;
  }





  getUserLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.IsLocationAllow = true;
      this.GeoLocation = "latitude:" + position.coords.latitude + ",longitude:" + position.coords.longitude;
    },
      (error) => {
        this.IsLocationAllow = false;
        let errorMessage = '';
        if (error.PERMISSION_DENIED) {
          errorMessage = `Couldn't get your location Permission denied. \n Please allow the location for access.`;
          swal("Error", errorMessage.toString(), "error");
        }
        else if (error.POSITION_UNAVAILABLE) {
          errorMessage = `Couldn't get your location Position unavailable. \n Please allow the location for access.`;
          swal("Error", errorMessage.toString(), "error");
        }
        else if (error.TIMEOUT) {
          errorMessage = `Couldn't get your location'+'Timed out.`;
          swal("Error", errorMessage.toString(), "Time Out");
        }
        else {
          swal(error.message + `Error: ${error.code}`);
        }
      }, { enableHighAccuracy: true }
    );
  }

 

  SendOtp() {
    this.sendotpbtn = false;
    let form = {
      AccountId: 0,
      AccountType: 0,
      AppName: "",
      RequestUserName: "",
      OtpRequestType: 0,
      OtpRequestReason: "",
      RequestRecordType: 0,
      RequestRecordId: "",
      RequestRecordDetail: "",
      RequestGeoLocation: "",
      RequstIPAddress: "",
      Source: "",
      Amount: '',
      UserType: "",
      UserId: "",

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.AccountId = merchantdata.MerchantKeyId;
    form.AccountType = 1;
    form.AppName = "FastSwiff Future POS";
    form.UserType = merchantdata.UserType;
    form.OtpRequestType = 1
    form.OtpRequestReason = "Payout Transaction Approval",
      form.RequestRecordType = 1,
      form.RequestRecordId = this.Id;
    form.RequestRecordDetail = "Payout Verification",
      form.RequestGeoLocation = this.GeoLocation;
    form.RequstIPAddress = this.CurrentIp
    form.RequestUserName = this.commonfunction.getUserName();
    form.Amount = this.Amt;
    form.UserId = merchantdata.UserId;
    this.service.InitiateOtp(form).subscribe(result => {
      if (result != null) {
        if (result.ResponseCode == "1" && result.ResponseText == "Approved") {
          swal("Sent", "Otp sent successfully", "success");
          this.Otptextbox = true;
        }
        else {
          this.ResponseText = result.ResponseText;
          this.Rcode = result.ResponseCode;
          this.DeclinePayouttransactions();
          // swal("", this.sendOtpResponseText, "warning");
          // if(result.ResponseCode=="2")
          // {
          //   this.DeclinePayouttransaction();
          // }
        }

      }
    });


  }
  otpverfication() {

    let form = {
      AccountId: 0,
      AccountType: 0,
      AppName: "",
      RequestUserName: "",
      OtpRequestType: 0,
      RequestRecordType: 0,
      RequestRecordId: "",
      RequestRecordDetail: "",
      RequestGeoLocation: "",
      RequstIPAddress: "",
      Otp: "",
      UserType: "",
      UserId: "",

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.AccountId = merchantdata.MerchantKeyId;
    form.AccountType = 1;
    form.AppName = "FastSwiff Future POS";

    form.OtpRequestType = 1
    form.RequestRecordType = 1,
      form.RequestRecordId = this.Id;
    form.RequestRecordDetail = "Payout Verification",
      form.RequestGeoLocation = this.GeoLocation;
    form.RequstIPAddress = this.CurrentIp
    form.RequestUserName = this.commonfunction.getUserName();
    form.Otp = this.Otp.value;
    form.UserType = merchantdata.UserType;
    form.UserId = merchantdata.UserId;
    this.service.VerifyOtp(form).subscribe(result => {
      if (result != null) {
        if (result.ResponseCode == "1" && result.ResponseText == "Approved") {
          this.openpopup();
        }
        else {
          this.ResponseText = result.ResponseText;
          this.Rcode = result.ResponseCode
          this.DeclinePayouttransactions();
          // swal("", this.ResponseText, "warning");
          // if(result.ResponseCode=="2")
          // {
          //   this.DeclinePayouttransaction();
          // }
        }

      }
    });


  }


  DeclinePayouttransactions() {

    swal({

      title: this.ResponseText,
      icon: 'warning',
      buttons: {

        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        if (this.Rcode == "2") {
          this.DeclinePayouttransaction();
        }


      }
    });
  }

  Otperrors() {
    return this.Otp.hasError("required")
      ? "Otp is required" : "";
  }
}
